/* eslint-disable @typescript-eslint/no-explicit-any -- retired dialog (see importFiles() stub below); not worth retrofitting types into dead code */
import { Component, inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { WorkOrderService } from '../../services/work-order/work-order.service';
import { UserPreferencesService } from '../../services/user-preferences/user-preferences.service';
import { LoaderService } from '../../services/loader/loader.service';
import { ToastService } from '../../services/toast/toast.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UtilsService } from '../../services/utils/utils.service';
import { GridActionButtons } from '../../../shared/models/common.model';

@Component({
  selector: 'app-import-woms-defect',
  // eslint-disable-next-line @angular-eslint/prefer-standalone -- pre-existing NgModule-declared component, now retired (docs/dotnet-api-migration-status.md, #5); standalone migration tracked under COL-36, not done piecemeal here
  standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './import-woms-defect.component.html',
  styleUrl: './import-woms-defect.component.scss',
})
export class ImportWomsDefectComponent implements OnInit {
  private workOrderService = inject(WorkOrderService);
  private userPreferencesService = inject(UserPreferencesService);
  private loaderService = inject(LoaderService);
  private toastService = inject(ToastService);
  private dialogRef = inject<MatDialogRef<ImportWomsDefectComponent>>(MatDialogRef);
  data = inject<{ projectId?: number }>(MAT_DIALOG_DATA);
  private utilsService = inject(UtilsService);

  userPreferencesData: any;
  selectedFile: any[] = [];
  GridActionButtons = GridActionButtons;

  ngOnInit() {
    this.userPreferencesData = this.userPreferencesService.getUserPreferencesData();
  }

  onFileSelected(event: any) {
    const files = event.target.files;
    if (files && files.length > 0) {
      const invalidFiles = Array.from(files).filter(
        (file: File) => !(file.name.endsWith('.xlsx') || file.name.endsWith('.xls'))
      );
      if (invalidFiles.length > 0) {
        this.toastService.showError('Only xlsx and xls files are allowed.');
        this.selectedFile = [];
        return;
      }
      this.selectedFile = files;
    } else {
      this.selectedFile = [];
    }
  }

  // This dialog's feature is retired: work-order-list.component.ts's "Import WOMS
  // Defect" menu entry (the only opener of this dialog) was removed in favor of
  // features/woms-defect-import's Node-based job-queue import, and the underlying
  // workOrderService.importWomsDefect() has been commented out. Kept as a stub rather
  // than removed because the template's "Import File" button still binds to this
  // method and Angular's template type-checking requires it to exist, even though
  // nothing can open this dialog anymore. Confirmed via repo-wide search, 2026-10-14.
  importFiles() {
    this.toastService.showError('This import option has been retired.');
    this.dialogRef.close();
  }

  removeFiles(event: any, fileInput: HTMLInputElement) {
    event.stopPropagation();
    this.selectedFile = [];
    fileInput.value = '';
  }

  cancel() {
    this.dialogRef.close();
  }
}
